import React from "react";
import ContactItem from "./ContactItem";
import ContactForm from "./ContactForm";

export default () => {
  const date = new Date().getFullYear();
  return (
    <section id="contact" className="contact col-padding">
      <div className="container">
        <h1 className="heading-1 mt-1 text-white">Contact</h1>
        <p className="heading-2">Get in touch</p>
        <ContactForm />
        <div className="contact__social">
          <ContactItem
            link="https://github.com/danielferreiradf"
            icon="fab fa-github"
          />
          <ContactItem
            link="https://twitter.com/danferreiradfs"
            icon="fab fa-twitter"
          />
          <ContactItem
            link="https://www.linkedin.com/in/danielferreiradf/"
            icon="fab fa-linkedin"
          />
        </div>
        <p className="contact__dev mt-1 mb-2">
          Developed by Daniel Ferreira &copy; {date}
        </p>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/Contact.js